import { Grid, Stack, Typography } from "@mui/material";
import React from "react";
import { Outlet } from "react-router-dom";


const Auth = () => {
    return (
        <Grid container className="auth-height" justifyContent="center" direction="column">
            <Grid item xs={3} sm={3}  >
                <Stack className="center-on-xs auth-logo-container" >
                    <img className="auth-logo" alt=""></img>
                </Stack>
            </Grid>
            <Grid item xs={9}>
                <Grid container className="auth-height" alignItems="center">
                    <Grid item xs={12} justifyContent="center" sx={{display:"flex"}}>
                        <Outlet />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default Auth;